import { useSelector } from "react-redux"

export const useCalendarJournalNoteDates = () => {
  return useSelector((state) => state.calendar?.journalNoteDates)
}

export const useCalendarTimeOff = () => {
  return useSelector((state) => state.calendar?.calendarTimeOff)
}
